
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[cartUrl]/[eventId]",
      function () {
        return require("private-next-pages/store/[cartUrl]/[eventId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[cartUrl]/[eventId]"])
      });
    }
  